(function () {
  function addScript(src, attrs) {
    var s = document.createElement('script');
    s.src = src;
    if (attrs) Object.keys(attrs).forEach(k => (s[k] = attrs[k]));
    document.head.appendChild(s);
    return s;
  }

  function addInline(fn) {
    var s = document.createElement('script');
    s.defer = true;
    s.textContent = '(' + fn.toString() + ')();';
    document.head.appendChild(s);
  }

  function loadPixelsAndUtilities() {
  
    // SiteMatch pixel
    addScript('https://xp2023-pix.s3.amazonaws.com/px_KCuQ8.js', { async: true, defer: true });

    // Hark
    addInline(function () {
      const s = document.createElement("script");
      s.src = "https://storage.googleapis.com/prod_harks/sendhark_handler.js?randomstr=" + Date.now();
      s.defer = true;
      s.onload = function () {
        if (window.harkEmbedJs) {
          harkEmbedJs.init("677852d40f7b96a1e9aa966f", "popup", "hark_contact_button");
        }
      };
      document.body.appendChild(s);
    });

  }

  // Load after paint
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadPixelsAndUtilities, { timeout: 3000 });
  } else {
    window.addEventListener('load', loadPixelsAndUtilities);
  }
})();

